(function () {
  if (customElements.get('product-info-tab-content')) {
    return;
  }

  function buildHtmlFromPayload(payload) {
    if (!payload || typeof payload !== 'object') {
      return '';
    }

    if (typeof payload.content === 'string' && payload.content.trim() !== '') {
      return payload.content;
    }

    var html = '';

    if (typeof payload.css === 'string' && payload.css.trim() !== '') {
      html += '<style>' + payload.css + '</style>';
    }

    if (typeof payload.html === 'string' && payload.html.trim() !== '') {
      html += payload.html;
    }

    if (typeof payload.js === 'string' && payload.js.trim() !== '') {
      html += '<script>' + payload.js + '<\/script>';
    }

    return html;
  }

  function isSchemaScript(script) {
    return script.getAttribute('type') === 'application/ld+json';
  }

  function extractSchemaScripts(root) {
    var schemas = [];

    root.querySelectorAll('script').forEach(function (script) {
      if (!isSchemaScript(script)) {
        return;
      }

      schemas.push(script.textContent);
      script.remove();
    });

    return schemas;
  }

  function mountSeoSchemas(host, schemas) {
    if (!schemas.length) {
      return;
    }

    var seoHost = document.createElement('div');
    seoHost.className = 'product-info-tab-content__seo';
    seoHost.setAttribute('data-seo-schema-host', '');
    seoHost.setAttribute('aria-hidden', 'true');

    schemas.forEach(function (schemaContent, index) {
      if (!schemaContent || !schemaContent.trim()) {
        return;
      }

      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-product-info-tab-schema', String(index));
      script.textContent = schemaContent;
      seoHost.appendChild(script);
    });

    if (seoHost.childNodes.length) {
      host.appendChild(seoHost);
    }
  }

  function activateScripts(root) {
    root.querySelectorAll('script').forEach(function (oldScript) {
      if (isSchemaScript(oldScript)) {
        return;
      }

      var newScript = document.createElement('script');

      Array.from(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });

      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function removeSeoSchemas(host) {
    host.querySelectorAll('[data-seo-schema-host]').forEach(function (seoHost) {
      seoHost.remove();
    });
  }

  class ProductInfoTabContent extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) {
        return;
      }

      var payloadScript = this.querySelector('script[data-tab-content-payload]');
      if (!payloadScript) {
        return;
      }

      var payload;

      try {
        payload = JSON.parse(payloadScript.textContent);
      } catch (error) {
        return;
      }

      var html = buildHtmlFromPayload(payload);
      payloadScript.remove();

      if (!html) {
        return;
      }

      var wrapper = document.createElement('div');
      wrapper.className = 'product-info-tab-content__root';
      wrapper.innerHTML = html;

      var schemas = extractSchemaScripts(wrapper);
      mountSeoSchemas(this, schemas);

      activateScripts(wrapper);

      var shadow = this.attachShadow({ mode: 'open' });
      shadow.appendChild(wrapper);
    }

    disconnectedCallback() {
      removeSeoSchemas(this);
    }
  }

  customElements.define('product-info-tab-content', ProductInfoTabContent);
})();
